'use strict';

/* eslint-disable no-underscore-dangle */

var Promise = require('bluebird');
var request = require('superagent');

var ENVIRONMENTS = require('./ScorekeeperEnvironments');

var EXPRESSION_INFLUENCERS_PATH = '/scoring/influencers?type=personalization';
var SERVICE_URLS = {};
SERVICE_URLS[ENVIRONMENTS.STAGING] = 'https://watch.product.api.staging.espn.com';
SERVICE_URLS[ENVIRONMENTS.PRODUCTION] = 'https://watch.product.api.espn.com';

// const JSON_DATA_SOURCE = (() => {
//     const expressionInfluencers = require('./expressionInfluencers.json');
//     return {
//         getBasicInfluencers: () => Promise.resolve([]),
//         getDynamicInfluencers: () => Promise.resolve(expressionInfluencers)
//     };
// })();

var _environment = void 0;
var _cache = void 0;

function getExpressionInfluencers() {
    var callback = arguments.length <= 0 || arguments[0] === undefined ? function () {} : arguments[0];

    if (_cache) {
        callback(_cache);return;
    }

    var url = '' + SERVICE_URLS[_environment] + EXPRESSION_INFLUENCERS_PATH;
    request.get(url).end(function (err, res) {
        if (err) {
            callback([]);return;
        }

        var influencers = res.body || [];
        _cache = influencers;
        callback(influencers);
    });
}

function primeCache() {
    getExpressionInfluencers();
}

function getDataSource() {
    return {
        getBasicInfluencers: function getBasicInfluencers() {
            return Promise.resolve([]);
        },
        getDynamicInfluencers: function getDynamicInfluencers() {
            return new Promise(function (resolve) {
                return getExpressionInfluencers(resolve);
            });
        }
    };
}

module.exports = function () {
    var environment = arguments.length <= 0 || arguments[0] === undefined ? ENVIRONMENTS.STAGING : arguments[0];

    _environment = environment;
    primeCache();
    return getDataSource();
};


//////////////////
// WEBPACK FOOTER
// ./~/watch-scorekeeper/dist/ScorekeeperDataSource.js
// module id = 816
// module chunks = 0